export default "__VITE_ASSET__C5c3ZaZO__"